import { mainUrl } from "../../../api/apiSettings";

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/journey
export const JOURNEY_QUERY = (groupId) => `${mainUrl}/journey/all/${groupId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/journey/{uniqueId}
export const JOURNEY_GET_SPECIFIC = (uniqueId) => `${mainUrl}/journey/${uniqueId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/journey/thumbnail/{journeyId}
export const JOURNEY_GET_THUMBNAIL = (uniqueId) => `${mainUrl}/journey/thumbnail/${uniqueId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/content/{contentType}/{uniqueId}
export const CONTENT_GET_SPECIFIC = (contentType, uniqueId) => `${mainUrl}/content/${contentType}/${uniqueId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/journey/subscription
export const HANDLE_JOURNEY_SUBSCRIPTION = `${mainUrl}/journey/subscription`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/user/{userId}/journey/inprogress
export const JOURNEY_FETCH_IN_PROGRESS = (userId) => `${mainUrl}/user/journey/${userId}/inprogress`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/user/journey/{userId}/completed
export const JOURNEY_FETCH_COMPLETED = (userId) => `${mainUrl}/user/journey/${userId}/completed`

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/user/journey/{userId}/{journeyId}
export const JOURNEY_GET_ITEMS_USER_PROGRESS = (userId, journeyId) => `${mainUrl}/user/journey/${userId}/${journeyId}`;

// PATCH - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/user/journey/progress
export const JOURNEY_PATCH_PROGRESS = `${mainUrl}/user/journey/progress`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/user/attendance
export const VALIDATE_ATTENDANCE = `${mainUrl}/user/attendance`

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/user/journey/complete
export const JOURNEY_COMPLETE = `${mainUrl}/user/journey/complete`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/journey/feedback
export const JOURNEY_FEEDBACK = `${mainUrl}/journey/feedback`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/tag
export const QUERY_TAGS = `${mainUrl}/tag`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/journey/quiz/{journeyId}/{contentId}/{userId}
export const QUIZ_GET_USER_ANSWER = (journeyId, contentId, userId) => `${mainUrl}/journey/quiz/${journeyId}/${contentId}/${userId}`;

